import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CarregamentoGlobalComponent } from './shared/components/carregamento-global/carregamento-global.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CarregamentoGlobalComponent],
  template: '<app-carregamento-global /><router-outlet></router-outlet>',
  styles: []
})
export class AppComponent {
  title = 'SPO – Sistema de Preços e Orçamentos';
}
